// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ListTagsWithEventCountsQueryVariables = PrivateSchemaTypes.Exact<{
  endingFrom: PrivateSchemaTypes.Scalars['JSON'];
}>;


export type ListTagsWithEventCountsQuery = (
  { __typename?: 'Query' }
  & { tags?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name' | 'eventsCount'>
  )>> }
);

export type ListEventsAsEditorQueryVariables = PrivateSchemaTypes.Exact<{
  endingFrom: PrivateSchemaTypes.Scalars['JSON'];
}>;


export type ListEventsAsEditorQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { events: Array<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title' | 'start_time' | 'end_time' | 'timezone' | 'location' | 'inviteesCount' | 'attendeesCount' | 'published_date' | 'participants_limit'>
        & { description: PrivateSchemaTypes.EventModelAsAdmin['descriptionStripped'] }
        & { recurringEvent?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'RecurringEventModelAsStudent' }
          & Pick<PrivateSchemaTypes.RecurringEventModelAsStudent, 'id'>
          & { recurrence?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'EventRecurrencePattern' }
            & Pick<PrivateSchemaTypes.EventRecurrencePattern, 'interval' | 'count' | 'byDay' | 'freq'>
          )> }
        )>, tags: Array<(
          { __typename?: 'TagModel' }
          & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
        )> }
      )> }
    )> }
  )> }
);


export const ListTagsWithEventCountsDocument = gql`
    query listTagsWithEventCounts($endingFrom: JSON!) {
  tags {
    id
    name
    eventsCount(
      filters: [{name: published}, {name: endingFrom, value: $endingFrom}]
    )
  }
}
    `;

/**
 * __useListTagsWithEventCountsQuery__
 *
 * To run a query within a React component, call `useListTagsWithEventCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsWithEventCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsWithEventCountsQuery({
 *   variables: {
 *      endingFrom: // value for 'endingFrom'
 *   },
 * });
 */
export function useListTagsWithEventCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListTagsWithEventCountsQuery, ListTagsWithEventCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListTagsWithEventCountsQuery, ListTagsWithEventCountsQueryVariables>(ListTagsWithEventCountsDocument, options);
      }
export function useListTagsWithEventCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListTagsWithEventCountsQuery, ListTagsWithEventCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListTagsWithEventCountsQuery, ListTagsWithEventCountsQueryVariables>(ListTagsWithEventCountsDocument, options);
        }
export type ListTagsWithEventCountsQueryHookResult = ReturnType<typeof useListTagsWithEventCountsQuery>;
export type ListTagsWithEventCountsLazyQueryHookResult = ReturnType<typeof useListTagsWithEventCountsLazyQuery>;
export type ListTagsWithEventCountsQueryResult = Apollo.QueryResult<ListTagsWithEventCountsQuery, ListTagsWithEventCountsQueryVariables>;
export const ListEventsAsEditorDocument = gql`
    query listEventsAsEditor($endingFrom: JSON!) {
  admin {
    organisation {
      id
      events(
        filters: [{name: published}, {name: endingFrom, value: $endingFrom}]
        order: [{name: "start_time"}]
      ) {
        id
        title
        start_time
        end_time
        timezone
        location
        description: descriptionStripped(length: 200)
        inviteesCount
        attendeesCount
        published_date
        participants_limit
        recurringEvent {
          id
          recurrence {
            interval
            count
            byDay
            freq
          }
        }
        tags {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useListEventsAsEditorQuery__
 *
 * To run a query within a React component, call `useListEventsAsEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsAsEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsAsEditorQuery({
 *   variables: {
 *      endingFrom: // value for 'endingFrom'
 *   },
 * });
 */
export function useListEventsAsEditorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListEventsAsEditorQuery, ListEventsAsEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListEventsAsEditorQuery, ListEventsAsEditorQueryVariables>(ListEventsAsEditorDocument, options);
      }
export function useListEventsAsEditorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListEventsAsEditorQuery, ListEventsAsEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListEventsAsEditorQuery, ListEventsAsEditorQueryVariables>(ListEventsAsEditorDocument, options);
        }
export type ListEventsAsEditorQueryHookResult = ReturnType<typeof useListEventsAsEditorQuery>;
export type ListEventsAsEditorLazyQueryHookResult = ReturnType<typeof useListEventsAsEditorLazyQuery>;
export type ListEventsAsEditorQueryResult = Apollo.QueryResult<ListEventsAsEditorQuery, ListEventsAsEditorQueryVariables>;